// Activity types and labels used across the app

export type ActivityType =
  | 'DRILLING'
  | 'COMPLETION'
  | 'PRODUCTION'
  | 'INTERVENTION'
  | 'RECLAMATION';

export const ACTIVITY_TYPES: ActivityType[] = [
  'DRILLING',
  'COMPLETION',
  'PRODUCTION',
  'INTERVENTION',
  'RECLAMATION',
];

export const ACTIVITY_LABEL: Record<ActivityType, string> = {
  DRILLING: 'Drilling',
  COMPLETION: 'Completion',
  PRODUCTION: 'Production',
  INTERVENTION: 'Intervention',
  RECLAMATION: 'Reclamation',
};

